exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".input-group-addon{\r\n    min-width: 41px;\r\n}\r\n.page-header{\r\n    padding-top: 9px;\r\n}\r\n.signaturenotrec {\r\n    font-size: 7px;\r\n    margin-top: -30px;\r\n}\r\n.sig_content{\r\n    line-height: 7px;\r\n    font-weight: 700;\r\n}\r\n\r\n.bankName_sub{\r\n    top: 14.5em;\r\n    left: 2.1em;\r\n    width: 300px;\r\n}\r\n.bankName_sub span{\r\n    font-size: 10px;\r\n}\r\n.inner-check-wrapper .UserSignatureDiv{\r\n    text-align: left;\r\n}\r\n.inner-check-wrapper .UserSignatureDiv .signaturenotrec{\r\n    text-align: center;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/create-cheque/create-cheque.component.css
// module id = ../../../../../src/app/create-cheque/create-cheque.component.css
// module chunks = main